import {
	SET_RELOAD_KPI_LIST,
	SET_SHOW_KPI_CREATE_OPEN,
	SET_CYCLE_DETAILS_DEFAULT_KPI,
	FAIL_CYCLE_DETAILS_DEFAULT_KPI,
	PENDING_CYCLE_DETAILS_DEFAULT_KPI,
	SET_KPI_TYPE,
	KPI_PROGRESS_PENDING,
	KPI_PROGRESS_SUCCESS,
	KPI_PROGRESS_FAILED,
	HIGHTLIGHT_KPI,
	SET_KPI_FILTER_CONDITION,
	RESET_KPI_FILTER_CONDITION,
} from '../action/actionTypes';

const INITIAL_STATE = {
	reloadKpiList: false,
	showKpiCreateOpen: false,
	cycleDetailsForDefaultKpi: null,
	kpiType: 3,
	highlightedId: {},
	dashboardProgressData: {},
	defaultSearchFilter: {
		kpiCategoryMasterId: [],
		status: [],
		searchText: '',
	},
	finalFilterCondition: {
		kpiCategoryMasterId: [],
		status: [],
		searchText: '',
	},
};

export default function kpiReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case SET_RELOAD_KPI_LIST:
			return { ...state, reloadKpiList: action.payload };
		case SET_SHOW_KPI_CREATE_OPEN:
			return { ...state, showKpiCreateOpen: action.payload };
		case SET_KPI_TYPE:
			return { ...state, kpiType: action.payload };
		case SET_KPI_FILTER_CONDITION:
			return { ...state, finalFilterCondition: action.payload };
		case RESET_KPI_FILTER_CONDITION:
			return { ...state, finalFilterCondition: state.defaultSearchFilter };
		case SET_CYCLE_DETAILS_DEFAULT_KPI:
			return { ...state, cycleDetailsForDefaultKpi: action.payload };
		case FAIL_CYCLE_DETAILS_DEFAULT_KPI:
			return { ...state, cycleDetailsForDefaultKpi: null };
		case PENDING_CYCLE_DETAILS_DEFAULT_KPI:
			return { ...state, cycleDetailsForDefaultKpi: null };
		case KPI_PROGRESS_PENDING: {
			return { ...state, dashboardProgressStatus: 'pending' };
		}
		case KPI_PROGRESS_SUCCESS: {
			return {
				...state,
				dashboardProgressData: action.payload.entity,
				dashboardProgressStatus: 'success',
			};
		}
		case HIGHTLIGHT_KPI: {
			return {
				...state,
				highlightedId: action.currentTab,
			};
		}
		case KPI_PROGRESS_FAILED: {
			return {
				...state,
				dashboardProgressData: {},
				dashboardProgressStatus: 'error',
			};
		}
		default:
			return { ...state };
	}
}
